/**
 * App Styles
 *
 * React Native Starter App
 * https://github.com/mcnamee/react-native-starter-app
 */
import { Platform } from "react-native";
import Colors from "./colors";
import Fonts from "./fonts";
import Sizes from "./sizes";

export default {
    appContainer: {
        backgroundColor: "#000",
    },

    // Default
    container: {
        position: "relative",
        flex: 1,
        flexDirection: "column",
        backgroundColor: Colors.background,
    },
    containerCentered: {
        justifyContent: "center",
        alignItems: "center",
    },
    windowSize: {
        height: Sizes.screen.height,
        width: Sizes.screen.width,
    },

    // Aligning items
    leftAligned: {
        alignItems: "flex-start",
    },
    centerAligned: {
        justifyContent: "center",
        alignItems: "center",
    },
    rightAligned: {
        alignItems: "flex-end",
    },

    // Text Styles
    baseText: {
        fontFamily: Fonts.base.family,
        fontSize: Fonts.base.size,
        lineHeight: Fonts.base.lineHeight,
        color: Colors.textPrimary,
        fontWeight: "500",
    },
    p: {
        fontFamily: Fonts.base.family,
        fontSize: Fonts.base.size,
        lineHeight: Fonts.base.lineHeight,
        color: Colors.textPrimary,
        fontWeight: "500",
        marginBottom: 8,
    },
    h1: {
        fontFamily: Fonts.h1.family,
        fontSize: Fonts.h1.size,
        lineHeight: Fonts.h1.lineHeight,
        color: Colors.headingPrimary,
        fontWeight: "800",
        margin: 0,
        marginBottom: 4,
        left: 0,
        right: 0,
    },
    h2: {
        fontFamily: Fonts.h2.family,
        fontSize: Fonts.h2.size,
        lineHeight: Fonts.h2.lineHeight,
        color: Colors.headingPrimary,
        fontWeight: "800",
        margin: 0,
        marginBottom: 4,
        left: 0,
        right: 0,
    },
    h3: {
        fontFamily: Fonts.h3.family,
        fontSize: Fonts.h3.size,
        lineHeight: Fonts.h3.lineHeight,
        color: Colors.headingPrimary,
        fontWeight: "500",
        margin: 0,
        marginBottom: 4,
        left: 0,
        right: 0,
    },
    h4: {
        fontFamily: Fonts.h4.family,
        fontSize: Fonts.h4.size,
        lineHeight: Fonts.h4.lineHeight,
        color: Colors.headingPrimary,
        fontWeight: "800",
        margin: 0,
        marginBottom: 4,
        left: 0,
        right: 0,
    },
    h5: {
        fontFamily: Fonts.h5.family,
        fontSize: Fonts.h5.size,
        lineHeight: Fonts.h5.lineHeight,
        color: Colors.headingPrimary,
        fontWeight: "800",
        margin: 0,
        marginTop: 4,
        marginBottom: 4,
        left: 0,
        right: 0,
    },
    strong: {
        fontWeight: "900",
    },
    link: {
        textDecorationLine: "underline",
        color: Colors.brand.primary,
    },
    subtext: {
        fontFamily: Fonts.base.family,
        fontSize: Fonts.base.size * 0.8,
        lineHeight: parseInt(Fonts.base.lineHeight * 0.8, 10),
        color: Colors.textSecondary,
        fontWeight: "500",
    },

    // Helper Text Styles
    textCenterAligned: {
        textAlign: "center",
    },
    textRightAligned: {
        textAlign: "right",
    },

    // Give me padding
    padding: {
        paddingVertical: Sizes.padding,
        paddingHorizontal: Sizes.padding,
    },
    paddingHorizontal: {
        paddingHorizontal: Sizes.padding,
    },
    paddingLeft: {
        paddingLeft: Sizes.padding,
    },
    paddingRight: {
        paddingRight: Sizes.padding,
    },

    paddingRightTriangle: {
        paddingRight: 12,
    },

    paddingVertical: {
        paddingVertical: Sizes.padding,
    },
    paddingTop: {
        paddingTop: Sizes.padding,
    },
    paddingBottom: {
        paddingBottom: Sizes.padding,
    },
    paddingSml: {
        paddingVertical: Sizes.paddingSml,
        paddingHorizontal: Sizes.paddingSml,
    },
    paddingHorizontalSml: {
        paddingHorizontal: Sizes.paddingSml,
    },
    paddingLeftSml: {
        paddingLeft: Sizes.paddingSml,
    },
    paddingRightSml: {
        paddingRight: Sizes.paddingSml,
    },
    paddingVerticalSml: {
        paddingVertical: Sizes.paddingSml,
    },
    paddingTopSml: {
        paddingTop: Sizes.paddingSml,
    },
    paddingBottomSml: {
        paddingBottom: Sizes.paddingSml,
    },
    paddingXs: {
        paddingVertical: Sizes.paddingXs,
        paddingHorizontal: Sizes.paddingXs,
    },
    paddingHorizontalXs: {
        paddingHorizontal: Sizes.paddingXs,
    },
    paddingLeftXs: {
        paddingLeft: Sizes.paddingXs,
    },
    paddingRightXs: {
        paddingRight: Sizes.paddingXs,
    },
    paddingVerticalXs: {
        paddingVertical: Sizes.paddingXs,
    },
    paddingTopXs: {
        paddingTop: Sizes.paddingXs,
    },
    paddingBottomXs: {
        paddingBottom: Sizes.paddingXs,
    },
    paddingTopXl: {
        paddingTop: 30,
    },


    marginTopXs: {
        marginTop: Sizes.paddingXs,
    },
    marginHorizontalXs: {
        marginHorizontal: Sizes.paddingXs,
    },

    // General HTML-like Elements
    hr: {
        left: 0,
        right: 0,
        borderBottomWidth: 1,
        borderBottomColor: Colors.border,
        height: 1,
        backgroundColor: "transparent",
        marginTop: Sizes.padding,
        marginBottom: Sizes.padding,
    },

    // Grid
    row: {
        left: 0,
        right: 0,
        flexDirection: "row",
    },
    flex1: {
        flex: 1,
    },
    flex2: {
        flex: 2,
    },
    flex3: {
        flex: 3,
    },
    flex4: {
        flex: 4,
    },
    flex5: {
        flex: 5,
    },
    flex6: {
        flex: 6,
    },

    // Navbar
    navbar: {
        backgroundColor: Colors.brand.primary,
        borderBottomWidth: 0,
    },
    navbarTitle: {
        color: "#ffffff",
        fontWeight: "bold",
        fontFamily: Fonts.base.family,
        fontSize: Fonts.base.size,
    },
    navbarButton: {
        tintColor: "#ffffff",
    },

    // TabBar
    tabbar: {
        backgroundColor: Colors.tabbar.background,
        borderTopColor: Colors.border,
        borderTopWidth: 1,
    },



    // Iml app common styles
    imlContainer: {
        flex: 1,
        alignItems: "stretch",
        backgroundColor:"#f4f4f4",
    },
    //Flex direction
    rowReverse:{
        flexDirection:"row-reverse",
    },
    col: {
        flexDirection: "column",
        alignItems: "center",
    },

    // Background color
    secondaryColor:{
        backgroundColor:"#eea236",
    },
    dangerColor:{
        backgroundColor:"#ed2f2f",
    },
    bgColorWhite20:{
        backgroundColor:"rgba(255,255,255,.2)",
    },
    bgColorWhite100:{
        backgroundColor:"#ffffff",
    },
    bgColorMain:{
        backgroundColor: Colors.brand.primary,
    },
    bgColorSecondary:{
        backgroundColor: Colors.brand.secondary,
    },
    bgColorMain100:{
        backgroundColor: Colors.brand.primaryLight,
    },
    bgColorSecondary100:{
        backgroundColor: Colors.brand.secondaryLight,
    },
    bgColorGrey100:{
        backgroundColor:Colors.textGrey,
    },

    // Error
    bgWhiteError:{
        backgroundColor:"rgba(237,47,47,.4)",
    },
    // Color
    colorWhite100:{
        color:"#ffffff",
    },
    colorWhite75:{
        color:"rgba(255,255,255,.75)",
    },
    colorDanger:{
        color:"#ed2f2f",
    },
    colorMain:{
        color:Colors.brand.primary,
    },

    // FontSize
    fontXxs:{
        fontSize:8,
    },
    fontXs:{
        fontSize:10,
    },
    font12:{
        fontSize:12,
    },
    font14:{
        fontSize:14,
    },
    font16:{
        fontSize:16,
    },
    font24:{
        fontSize:24,
    },
    font32:{
        fontSize:32,
    },

    // Gap
    marginTop30:{
        marginTop:30,
    },
    marginTop20:{
        marginTop:20,
    },
    marginTop10:{
        marginTop:10,
    },
    marginTop5:{
        marginTop:5,
    },
    marginTop1:{
        marginTop:1,
    },
    marginTop2:{
        marginTop:2,
    },
    marginTop0:{
        marginTop:0,
    },
    marginLeft5:{
        marginLeft:5,
    },
    marginLeft20:{
        marginLeft:20,
    },
    marginRight10:{
        marginRight:10,
    },
    marginRight2:{
        marginRight:2,
    },
    marginRight5:{
        marginRight:5,
    },
    marginBottom2:{
        marginBottom:2,
    },
    marginBottom1:{
        marginBottom:1,
    },
    marginBottom5:{
        marginBottom:5,
    },
    marginBottom10:{
        marginBottom:10,
    },
    marginBottom20:{
        marginBottom:20,
    },
    marginHorizontal30:{
        marginHorizontal:30,
    },
    marginHorizontal10:{
        marginHorizontal:10,
    },
    marginHorizontal0:{
        marginHorizontal:0,
    },
    marginVertical10:{
        marginVertical:10,
    },
    marginVerticalXs:{
        marginVertical:5,
    },
    HVPaddingXS:{
        paddingHorizontal:10,
        paddingVertical:8,
    },
    HPaddingXS:{
        paddingHorizontal:10,
    },
    HPaddingMD:{
        paddingHorizontal:20,
    },
    VPaddingXS:{
        paddingVertical:5,
    },
    HVPaddingMD:{
        paddingHorizontal:20,
        paddingVertical:16,
    },

    // Layout
    alignSelfStart:{
        alignSelf:"flex-start",
    },
    alignSelfstretch:{
        alignSelf:"stretch",
    },
    alignSelfCenter:{
        alignSelf:"center",
    },
    alignSelfEnd:{
        alignSelf:"flex-end",
    },
    resizeModeContain:{
        resizeMode:"contain",
    },
    justifyFlexEnd:{
        justifyContent: "flex-end",
    },
    alignItemsStretch:{
        alignItems:"center",
    },
    alignItemsTop:{
        alignItems:"flex-start",
    },
    justifyContentCenter: {
        justifyContent: "center",
    },
    fleWrap: {
        flexWrap: "wrap",
    },


    // Width
    widthNull:{
        width:null,
        height:null
    },

    // Border line
    bottomUnderline2:{
        borderBottomWidth: 2,
        borderColor: Colors.background,
    },
    Topline:{
        borderTopWidth: 1,
        borderColor: Colors.background,
    },
    Topline2:{
        borderTopWidth: 2,
        borderColor: Colors.background,
    },
    leftBorder1:{
        borderLeftWidth: 1,
        borderColor: Colors.background,
    },
    rightBorder1:{
        borderRightWidth: 1,
        borderColor: Colors.background,
    },
    borderWidth2:{
        borderWidth:2,
        borderColor:"rgba(255,255,255,.5)",
    },
    borderBottom1:{
        borderBottomWidth: 1,
        borderColor: Colors.background,
    },
    borderSuccess:{
        borderWidth:2,
        borderColor: "#5cb85c",
    },
    borderDanger:{
        borderWidth:2,
        borderColor: Colors.brand.secondary,
    },
    borderPrimary:{
        borderWidth:2,
        borderColor: Colors.brand.primary,
    },
    borderWarning:{
        borderWidth:2,
        borderColor: Colors.brand.warning,
    },
    borderGray:{
        borderWidth:2,
        borderColor: Colors.textGreyDark,
    },
    borderWhite54:{
        borderWidth:2,
        borderColor: Colors.textWhite54,
    },
    withoutBorder: {
        borderWidth: 0,
    },


    // Avatar
    get xsmallAvatarBorder(){
        return {
            width:24,
            height:24,
            borderRadius:12,
            //borderWidth:1,
            //borderColor: Colors.textGreyDark,
            get backgroundColor() {
                return Colors.brand.primary;
            },
        };
    },
    xsmallAvatar:{
        width:24,
        height:24,
        borderRadius:12,
    },
    smallAvatar:{
        width:32,
        height:32,
        borderRadius:16,
    },
    get smallAvatarBorder() {
        return {
            width: 32,
            height: 32,
            borderRadius: 16,
            //borderWidth: 1,
            //borderColor: Colors.textGreyDark,
            get backgroundColor() {
                return Colors.brand.primary;
            },
        };
    },
    mediumAvatar:{
        width:48,
        height:48,
        borderRadius:24,
    },
    get mediumAvatarBorder() {
        return {
            width: 48,
            height: 48,
            borderRadius: 24,
            //borderWidth: 1,
            //borderColor: Colors.textGreyDark,
            get backgroundColor() {
                return Colors.brand.primary;
            },
        };
    },
    get mediumAvatarSquareBorder() {
        return {
            width: 48,
            height: 48,
            borderRadius:4,
            get backgroundColor() {
                return "#CCC";
            },
        };
    },
    xLargeAvatar: {
        width: 192,
        height: 192,
        borderRadius: 96,
    },
    get xLargeAvatarBorder() {
        return {
            width: 192,
            height: 192,
            borderRadius: 96,
            //borderWidth: 1,
            //borderColor: Colors.textGreyDark,
            get backgroundColor() {
                return Colors.brand.primary;
            },
        };
    },
    mediumTransparentBorder: {
        width: 54,
        height: 54,
        borderRadius: 27,
        borderWidth: 3,
        borderColor: "rgba(255,255,255,.20)",
    },
    calendarCircleBorder: {
        width: 42,
        height: 42,
        borderRadius: 21,
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
    },
    get calendarCircleBg() {
        return {
            width: 42,
            height: 42,
            borderRadius: 21,
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            get backgroundColor() {
                return Colors.brand.primary;
            },
        };
    },

    largeAvatar: {
        width: 58,
        height: 58,
        borderRadius: 29,
    },
    get largeAvatarBorder() {
        return {
            width: 58,
            height: 58,
            borderRadius: 29,
            //borderWidth: 2,
            //borderColor: Colors.textGreyDark,
            get backgroundColor() {
                return Colors.brand.primary;
            },
        };
    },

    largeTransparentBorder: {
        width: 64,
        height: 64,
        borderRadius: 32,
        borderWidth: 3,
        borderColor: "rgba(255,255,255,.20)",
    },
    mediumAvatarSquare:{
        width:48,
        height:48,
    },

    squareWithborderRadius: {
        borderWidth: 1, borderColor: "#E1E1E1", width: 50, height: 50, borderRadius: 4,
    },

    // Item list
    itemListXs:{
        left: 0,
        right: 0,
        flexDirection: "row",
        paddingVertical:5,
        borderTopWidth:1,
        borderColor: Colors.background,
    },
    listViewRow:{
        borderColor:"#f4f4f4",
        height:34,
        paddingVertical:4,
    },

    overlay: {
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: "#001730",
        opacity: 0.57
    },

    greyOverlay: {
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: "#0F0F0F",
        opacity: 0.7
    },

    //new message dot
    newMessageDotStyle: {
        position: "absolute",
        top: 0,
        right: 1,
        width: 6,
        height: 6,
        borderRadius: 3,
        backgroundColor:"red"
    },

    //calendar dot
    eventDotStyle: {
        position: "absolute",
        top: 33,
        right: 18,
        width: 6,
        height: 6,
        borderRadius: 3,
        backgroundColor: Colors.brand.warning
    },

    //pagination dot
    paginationDot: {
        width: 6,
        height: 6,
        borderRadius: 3,
    },

    //me gender icon
    genderIconCircle: {
        width: 18,
        height: 18,
        borderRadius: 9,
        position:"absolute",
        bottom:0,
        right:0,
        borderWidth: 1,
        borderColor: Colors.textWhite54,

    },

    //text input
    borderInput: {
        borderRadius: 4,
        borderWidth: 1,
        borderColor: "#E1E1E1",
        paddingHorizontal: 10,
        paddingVertical: 5,
        height: 36,
        //fontSize: (Platform.OS === "ios") ? 15 : 12,
    },

    //bg image
    bgImage: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },

    coverImage: {
        flex: 1,
        width: null,
        height: null,
        resizeMode: "cover"
    },

    //border
    borderBtn: {
        borderRadius: 4,
        borderWidth: 1,
        borderColor: "#E1E1E1",
        height: 42
    },

    //message box style text
    toastContainer: {
        backgroundColor: "rgba(0,0,0,0.8)",
        borderRadius: (Platform.OS==="ios") ? 5 : 0,
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        padding: 10,
        minHeight: 50,
        margin:10,
    },

    toastText: {
        color: "#fff",
        flex: 1,
        fontSize: 14
    },

    //border btn
    ghostBtnXs: {
        borderColor: "#E1E1E1",
        borderWidth: 1,
        height: 22,
        borderRadius: 22,
        paddingHorizontal: 10,
        justifyContent: "center",
    },
    ghostBtnMd: {
        borderWidth: 1,
        height: 36,
        borderRadius: 4,
        backgroundColor: "transparent",
    },

    //status line
    statusLine: {
        width: 5,
        height: 40,
        borderRadius: 5,
        position: "absolute",
        left: -11,
        top: 5,
    },

    //view shadow
    boxShadow:{
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 1.5,
    },

    btnShadow:{
        shadowColor: "#000",
        shadowOffset: { width: 2, height: 4 },
        shadowOpacity: 0.35,
        shadowRadius: 3,
    },

    //Talk Bubble
    talkBubbleRow: {
        paddingRight: 60,
        paddingTop:10,
    },
    talkBubble: {
        paddingLeft:15,
    },
    talkBubbleRight: {
        paddingRight:15,
    },
    talkBubbleSquare: {
        backgroundColor: "#fff",
        borderRadius: 4,
        paddingHorizontal:10,
        paddingVertical:8,
    },
    talkBubbleTriangle: {
        position: "absolute",
        left: 7,
        top: 10,
        width: 0,
        height: 0,
        borderTopColor: "transparent",
        borderTopWidth: 7,
        borderRightWidth: 10,
        borderRightColor: "#fff",
        borderBottomWidth: 7,
        borderBottomColor: "transparent",
    },
    talkBubbleTriangleRight: {
        position: "absolute",
        right: 7,
        top: 10,
        width: 0,
        height: 0,
        borderTopColor: "transparent",
        borderTopWidth: 7,
        borderLeftWidth: 10,
        borderLeftColor: "#fff",
        borderBottomWidth: 7,
        borderBottomColor: "transparent",
    },

    //Playoff Bracket
    BracketBox: {
        backgroundColor:"#fff",
        borderRadius:4,
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.1,
        shadowRadius: 1.5,
    },

    //
    fontSmall: {
        fontSize: Fonts.textSizeSmall,
    },

    borderRadiusXs: {
        borderRadius: 2,
    },

    //background transparent
    bgTransparent: {
        backgroundColor: "transparent",
    },

    //absolute position circle button
    circleBtn: {
        position: "absolute", right: -5, top: -9, backgroundColor: "#D0011B", borderRadius: 11, width: 18, height: 18,
    },

    circleBtnSml: {
        backgroundColor: "rgba(0,0,0,.2)", borderRadius: 21, width: 42, height: 42,
    },

    //fixed footer view
    fixedFooter:{
        position:"absolute",
        bottom:0,
        left:0,
        right:0,
        backgroundColor: "#F5F5F5",
        borderTopColor: Colors.border,
        padding: 10,
    },

    overflowHidden:{
        overflow: "hidden"
    },

    headerIcon: {
        fontSize: 30,
        color: "#777"
    },
};
